export const formPageFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  Title_Translation__c: 'titleTranslationId',
  Copy_of__c: 'copyOf',
  Origin__c: 'origin',
  Status__c: 'status',
  Type__c: 'type',
  Comments__c: 'comments',
  Data__c: 'data',
  Holds_Reusable_Elements__c: 'holdsReusableElements'
}

export interface FormPage {
  id: string
  name: string
  status?: string
  type?: string
  comments?: string
  data?: string
  titleTranslation?: string
  holdsReusableElements?: boolean
  origin?: string
  objectsConnected?: Record<string, string>
  titleTranslationId: string
  copyOfId?: string
  originId?: string
}
